module.exports = __webpack_public_path__ + "static/media/pdfmorado.fbda4c62.svg";